// dataSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { tokenVerification } from "../commonFunc/verification";
import GlobalURL from "../baseUrl";

const Language = localStorage.getItem("lang");

const initialState = {
  reportsData: [],
  loadingReports: false,
  errorReports: null,

  reportsStatements: [],
  loadingReportsStatements: false,
  errorReportsStatements: null,
};

export const fetchDataReports = createAsyncThunk(
  "data/fetchDataReports",
  async () => {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    const url = `${GlobalURL}/api/dev/admin/getReportDetails`;
    const headers = {
      "Content-Type": "application/json",
      lang_id: Language,
      token: `${Newtoken}`,
      "ngrok-skip-browser-warning": "69420",
    };

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  }
);

export const fetchDataStatements = createAsyncThunk(
  "data/fetchDataStatements",
  async () => {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    const url = `${GlobalURL}/api/dev/admin/getReportContent`;
    const headers = {
      "Content-Type": "application/json",
      lang_id: Language,
      token: `${Newtoken}`,
      "ngrok-skip-browser-warning": "69420",
    };

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  }
);

const dataSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataReports.pending, (state) => {
        state.loadingReports = true;
        state.errorReports = null;
      })
      .addCase(fetchDataReports.fulfilled, (state, action) => {
        state.loadingReports = false;
        state.reportsData = action.payload;
      })
      .addCase(fetchDataReports.rejected, (state, action) => {
        state.loadingReports = false;
        state.errorReports = action.error.message;
      })
      .addCase(fetchDataStatements.pending, (state) => {
        state.loadingReportsStatements = true;
        state.errorReportsStatements = null;
      })
      .addCase(fetchDataStatements.fulfilled, (state, action) => {
        state.loadingReportsStatements = false;
        state.reportsStatements = action.payload;
      })
      .addCase(fetchDataStatements.rejected, (state, action) => {
        state.loadingReportsStatements = false;
        state.errorReportsStatements = action.error.message;
      });
  },
});

export default dataSlice.reducer;
